import axios from "axios";

export const getVessels = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Vessel/vessels`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
